<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-button @click="open">打开消息提示</ot-button>
            <ot-button @click="openVn">VNode</ot-button>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-button%20%40click%3D%22open%22%3E%E6%89%93%E5%BC%80%E6%B6%88%E6%81%AF%E6%8F%90%E7%A4%BA%3C%2Fot-button%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-button%20%40click%3D%22openVn%22%3EVNode%3C%2Fot-button%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%20%20%20%20methods%3A%20%7B%0A%20%20%20%20%20%20%20%20open()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20this.%24otMessage('%E8%BF%99%E6%98%AF%E4%B8%80%E6%9D%A1%E6%B6%88%E6%81%AF%E6%8F%90%E7%A4%BA')%3B%0A%20%20%20%20%20%20%20%20%7D%2C%0A%0A%20%20%20%20%20%20%20%20openVn()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20const%20h%20%3D%20this.%24createElement%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20this.%24otMessage(%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20message%3A%20h('p'%2C%20null%2C%20%5B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20h('span'%2C%20null%2C%20'%E5%86%85%E5%AE%B9%E5%8F%AF%E4%BB%A5%E6%98%AF%20')%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20h('i'%2C%20%7B%20style%3A%20'color%3A%20teal'%20%7D%2C%20'VNode')%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%5D)%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20theme%3A%20this.%24otTheme%2C%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
    methods: {
        open() {
            this.$otMessage('这是一条消息提示');
        },

        openVn() {
            const h = this.$createElement;
            this.$otMessage({
                message: h('p', null, [
                    h('span', null, '内容可以是 '),
                    h('i', { style: 'color: teal' }, 'VNode'),
                ]),
                theme: this.$otTheme,
            });
        },
    },
};
</script>
